import { PaginationList } from './PaginationList';

// TODO: in v9, move styled() from PaginationList.jsx to here
export var StyledPaginationList = PaginationList;